import request from '@/request/request'

/**
 * 经济类型字典查询
 * @returns 
 */
export function getEconomicType () {
  return request({
    url: '/external-service-center/shexgrpDictionaries/economicType',
    method: 'get',
  })
}

/**
 * 币种字典查询
 * @returns 
 */
export function getCurrency () {
  return request({
    url: '/external-service-center/shexgrpDictionaries/currency',
    method: 'get',
  })
}

/**
 * 权证类型查询
 * @returns 
 */
export function getPropertyType () {
  return request({
    url: '/external-service-center/shexgrpDictionaries/propertyType',
    method: 'get',
  })
}

/**
 * 权证类型其他-标签
 * @returns 
 */
export function getLabel () {
  return request({
    url: '/external-service-center/shexgrpDictionaries/label',
    method: 'get',
  })
}

/**
 * 获取位置省份列表
 * @returns 
 */
export function getProvinceList () {
  return request({
    url: '/external-service-center/shexgrpDictionaries/provinceList',
    method: 'get',
  })
}

/**
 * 获取城市/地区列表
 * @returns 
 */
export function getAreaList (parameter) {
  return request({
    url: 'https://api.jssyjt.net/external-service-center/shexgrpDictionaries/areaList',
    method: 'post',
    data: parameter
  })
}

/**
 * 所属地段
 * @returns 
 */
export function getDistrict () {
  return request({
    url: '/external-service-center/shexgrpDictionaries/district',
    method: 'get',
  })
}

/**
 * 所属板块
 * @returns 
 */
export function getBlock () {
  return request({
    url: '/external-service-center/shexgrpDictionaries/block',
    method: 'get',
  })
}

/**
 * 权利人类型
 * @returns 
 */
export function getObligeeType () {
  return request({
    url: '/external-service-center/shexgrpDictionaries/obligeeType',
    method: 'get',
  })
}

/**
 * 房屋状态
 * @returns 
 */
export function getHouseStatus () {
  return request({
    url: '/external-service-center/shexgrpDictionaries/houseStatus',
    method: 'get',
  })
}

/**
 * 租赁用途
 * @returns 
 */
export function getLeaseUseType () {
  return request({
    url: '/external-service-center/shexgrpDictionaries/leaseUseType',
    method: 'get',
  })
}

/**
 * 公开招租列表项目状态筛选项字典

 * @returns 
 */
export function getBidApplyProjectOption () {
  return request({
    url: '/external-service-center/shexgrpDictionaries/bidApplyProjectOption',
    method: 'get',
  })
}

/**
 * 意向招租列表项目状态筛选项字典
 * @returns 
 */
export function getIntentLeaseProjectType () {
  return request({
    url: '/external-service-center/shexgrpDictionaries/intentLeaseProjectType',
    method: 'get',
  })
}

/**
 * 国家字典
 * @returns 
 */
export function getCountry () {
  return request({
    url: '/external-service-center/shexgrpDictionaries/country',
    method: 'get',
  })
}

/**
 * 商业细分业态-业务字典
 * @returns 
 */
export function getBusinessCategories () {
  return request({
    url: 'https://api.jssyjt.net/external-service-center/shexgrpDictionaries/businessCategories',
    method: 'get',
  })
}

/**
 * 园区细分业态-业务字典
 * @returns 
 */
export function getParkCategories () {
  return request({
    url: 'https://api.jssyjt.net/external-service-center/shexgrpDictionaries/parkCategories',
    method: 'get',
  })
}

/**
 * 所属集团企业树
 * @returns 
 */
export function getOrgTree () {
  return request({
    url: '/external-service-center/shexgrpDictionaries/orgTree',
    method: 'get',
  })
}

/**
 * 国资监管企业列表
 * @returns 
 */
export function getOrgList () {
  return request({
    url: '/external-service-center/shexgrpDictionaries/orgList',
    method: 'get',
  })
}

